export const MAX_SIZE = 10 * 1000 * 1000; // 10MB
export const ACCEPT_FILE_TYPES = [
  {
    mimeType: "application/pdf",
    extensions: ["pdf"],
  },
  {
    mimeType: "image/jpeg",
    extensions: ["jpg", "jpeg"],
  },
  {
    mimeType: "image/png",
    extensions: ["png"],
  },
  {
    mimeType: "image/tiff",
    extensions: ["tif", "tiff"],
  },
  {
    mimeType: "application/msword",
    extensions: ["doc"],
  },
  {
    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    extensions: ["docx"],
  },
  {
    mimeType: "application/vnd.ms-excel",
    extensions: ["xls"],
  },
  {
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    extensions: ["xlsx"],
  },
];
export const ACCEPT_STRING = ".pdf,.jpg,.jpeg,.png,.tif,.tiff,.doc,.docx,.xls,.xlsx";
export const MAX_FILE_CONTRACT_UPLOAD = 5;
